<template>
  <div class="w-full max-w-4xl mx-auto px-4">
    <!-- Company Information -->
    <h3 class="text-xl font-semibold mb-4 bg-gray-900 rounded-lg px-4 py-2">
      Company Information
    </h3>
    <div class="space-y-4 mb-8">
      <div
        v-for="setting in companySettings"
        :key="setting.key"
        class="flex flex-col sm:flex-row sm:items-center gap-2"
      >
        <div class="sm:w-[300px]">
          <label class="font-medium block sm:text-left">
            {{ setting.name }}
          </label>
        </div>
        <div class="flex-1 sm:w-[400px]">
          <el-input v-model="store.settings[setting.key]" />
        </div>
      </div>
    </div>

    <!-- Review Portal Settings -->
    <h3 class="text-xl font-semibold mb-4 bg-gray-900 rounded-lg px-4 py-2">
      Review Portal Settings
    </h3>
    <div class="space-y-4 mb-8">
      <div
        v-for="setting in reviewSettings"
        :key="setting.key"
        class="flex flex-col sm:flex-row sm:items-center gap-2"
      >
        <div class="sm:w-[300px]">
          <label class="font-medium block sm:text-left">
            {{ setting.name }}
          </label>
        </div>
        <div class="flex-1 sm:w-[400px]">
          <el-input v-model="store.settings[setting.key]" />
        </div>
      </div>
    </div>

    <!-- Portal Images -->
    <h3 class="text-xl font-semibold mb-4 bg-gray-900 rounded-lg px-4 py-2">
      Portal Images
    </h3>
    <div class="space-y-4 mb-8">
      <div
        v-for="setting in imageSettings"
        :key="setting.key"
        class="flex flex-col sm:flex-row sm:items-center gap-2"
      >
        <div class="sm:w-[300px]">
          <label class="font-medium block sm:text-left">
            {{ setting.name }}
          </label>
        </div>
        <div class="flex-1 sm:w-[400px]">
          <el-input v-model="store.settings[setting.key]" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ElInput } from "element-plus";
import { reactive } from "vue";
import { useUser } from "@/stores";
const store = useUser();

const companySettings = reactive([
  { name: "Company Name", key: "companyName" },
  { name: "Company Short Name", key: "companyShortName" },
  { name: "Company Email", key: "companyEmail" },
  { name: "Company Home Link", key: "companyHomeLink" },
  { name: "Phone Number", key: "phoneNumber" },
  { name: "Address", key: "address" },
]);

const reviewSettings = reactive([
  { name: "Feedback Question", key: "feedbackQuestion" },
  { name: "Positive Feedback Link", key: "companyReviewLink" },
  { name: "Thank You Message", key: "thankYouMessage" },
]);

const imageSettings = reactive([
  { name: "Payment Options Image Url", key: "paymentOptionsImageUrl" },
  { name: "Experience Review Image Url", key: "experienceReviewImageUrl" },
  { name: "Thank You Image Url", key: "thankYouImageUrl" },
  { name: "Payment Portal Image Url", key: "paymentPortalImageUrl" },
  { name: "Review Portal Image Url", key: "reviewPortalImageUrl" },
]);
</script>
<style scoped>
:deep(.el-table__header) {
  display: none;
}
</style>
